import { createReducer } from "@reduxjs/toolkit";
import { deleteTastePanelAsync, deleteTastePanelsBulkAsync, getTastePanelListSuccess, loadingTastePanelData, loadingTastePanelList, saveTastePanelListSuccess } from "./tastePanelAction";


export interface ITastePanelState {
  tastePanelList: Array<any>;
  dataCount: number;
  isLoading: boolean;
}

const initialState: ITastePanelState = {
  tastePanelList: [],
  dataCount: 0,
  isLoading: false,
};

export const tastePanelReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadingTastePanelData, (state, action) => {
      state.isLoading = action.payload;
    })
    .addCase(getTastePanelListSuccess, (state, action) => {
      state.tastePanelList = action.payload?.data ?? [];
      state.dataCount = action.payload?.dataCount ?? 0;
    })
    .addCase(saveTastePanelListSuccess, (state, action) => {
      state.tastePanelList = action.payload;
    })
    .addCase(loadingTastePanelList, (state, action) => {
      state.isLoading = action.payload;
    })
    .addCase(deleteTastePanelAsync.fulfilled, (state, action) => {
      if (action.payload.success) {
        state.tastePanelList = state.tastePanelList.filter(
          (item) => String(item.id) !== String(action.payload.id)
        );
        state.dataCount = Math.max(0, state.dataCount - 1);
      }
    })
    .addCase(deleteTastePanelsBulkAsync.fulfilled, (state, action) => {
      const { ids, failedIds = [] } = action.payload;

      const successfullyDeletedIds = ids.filter(id => !failedIds.includes(id));

      state.tastePanelList = state.tastePanelList.filter(
        (item) => !successfullyDeletedIds.includes(item.id)
      );

      state.dataCount = Math.max(0, state.dataCount - successfullyDeletedIds.length);
    });

});